// Settings page placeholder

export default function SettingsPage() {
	return null;
}
